import {Icon, IconName} from '@dv5/components'
import React, {FC} from 'react'
import './DocumentOutlineToggle.less'

interface Props {
    layoutId: string
    showOutline: boolean
    onToggle: () => void
    iconColor?: string
}

export const DocumentOutlineToggle: FC<Props> = ({layoutId, showOutline, onToggle, iconColor}) => {
    const label = showOutline ? 'Hide document outline' : 'Show document outline'

    return (
        <button type="button" className="documentOutlineToggle"
                style={iconColor ? {color: iconColor} : undefined}
                aria-label={label}
                title={label}
                aria-expanded={showOutline}
                aria-controls={`document-outline-${layoutId}`}
                onClick={onToggle}>
            <Icon name={IconName.List} width="18" height="18"/>
        </button>
    )
}
